<template>
  <div class="alterphone">
    <!-- <van-nav-bar :title=" this.$store.state.userCount.mobile!=null?'更换手机号':'绑定手机号'" left-text="" fixed  @click-right="onClickRight">
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: .25rem" @click="goBack"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav
      :title="this.$store.state.userCount.mobile != null ? '更换手机号' : '绑定手机号'"
    ></GlobTopNav>
    <div class="van-content">
      <!--已绑定-->
      <div v-if="this.$store.state.userCount.mobile">
        <div v-if="this.step == 0">
          <van-cell-group>
            <div to="/user/personal/weixin" class="van-cell van-hairline">
              <div class="van-cell__title">
                <span class="col-666">您已经绑定</span>
              </div>
              <span class="col-333" v-html="this.$store.state.userCount.mobile"></span>
            </div>
          </van-cell-group>
          <van-cell-group style="background: transparent">
            <van-cell style="background: transparent">
              <van-button size="large" class="save" @click="next"> 更换手机号 </van-button>
            </van-cell>
          </van-cell-group>
        </div>
        <div v-if="this.step == 1">
          <van-cell-group>
            <div class="van-cell van-hairline van-field van-field--has-icon">
              <img src="./../../../assets/img/iphone.svg" alt="" />
              <div class="van-cell__value">
                <input
                  onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                  type="number"
                  placeholder="请输入新手机号"
                  v-model="mobile"
                  class="van-field__control"
                />
              </div>
            </div>
            <div class="codebox van-cell van-field">
              <div class="van-cell__value van-cell__value--alone">
                <div class="van-field__body">
                  <img src="./../../../assets/img/login-code.svg" alt="" />
                  <input
                    type="text"
                    placeholder="请输入验证码"
                    class="van-field__control"
                    v-model="code"
                  />
                  <div class="van-field__button">
                    <button @click="getNvc()" class="get-code">
                      <span :loading="codeLoading" class="van-button__text">获取验证码</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </van-cell-group>
          <van-cell style="background: transparent">
            <van-button size="large" class="save" @click="sendData">确定 </van-button>
          </van-cell>
        </div>
      </div>
      <!--未绑定-->
      <div v-if="!this.$store.state.userCount.mobile">
        <van-cell-group>
          <div class="van-cell van-hairline van-field van-field--has-icon">
            <img src="./../../../assets/img/iphone.svg" alt="" />
            <div class="van-cell__value">
              <input
                onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                type="number"
                placeholder="请输入新手机号"
                v-model="mobile"
                class="van-field__control"
              />
            </div>
          </div>
          <div class="codebox van-cell van-field">
            <div class="van-cell__value van-cell__value--alone">
              <div class="van-field__body">
                <img src="./../../../assets/img/login-code.svg" alt="" />
                <input
                  type="text"
                  placeholder="请输入验证码"
                  class="van-field__control"
                  v-model="code"
                />
                <div class="van-field__button">
                  <button @click="getNvc()" class="get-code">
                    <span :loading="codeLoading" class="van-button__text">获取验证码</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </van-cell-group>
        <van-button size="large" class="save" @click="sendData">确定</van-button>
      </div>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "../../login/components/nvc";
export default {
  name: "phone",
  data() {
    return {
      oldmobile: "",
      mobile: "",
      code: "",
      codeLoading: false,
      No: "",
      step: 0,
      dd: ""
    };
  },
  components: {
    Nvc
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    next: function() {
      this.step = 1;
    },
    onClickRight() {
      console.log("按钮");
    },
    sendData: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var code = this.No + "_" + this.code;
      this.$api.post(
        "user/user/setphone",
        {
          id_example: mallid,
          token_user: isUser,
          phone: this.mobile,
          code: code
        },
        res => {
          if (res.data.code == "100") {
            this.$store.commit("userInfo");
            this.$toast(res.data.message);
            history.back(-1);
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    },
    getNvc: function() {
      // 进行人机验证
      var reg = /^[1][3456789][0-9]{9}$/;
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      this.$refs.nverify.startVerify()
    },
    getCode: function(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var _this = this;
        var mallid = localStorage.getItem("mallid");
        if (this.codeLoading == false) {
          this.codeLoading = true;
          this.$api.post(
            "message",
            { id_example: mallid, phone: this.mobile, type: 3, captchaVerifyParam },
            res => {
              if (res.data.code == "100") {
                resolve(true)
                this.No = res.data.data;
                var time = 60;
                _this.dd = setInterval(function() {
                  time--;
                  $(".alterphone .codebox .van-button").html(time + " s");
                  if (time <= 0) {
                    clearInterval(_this.dd);
                    _this.codeLoading = false;
                    $(".alterphone .codebox .van-button").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
                this.$toast("发送成功请注意查收");
              } else if(res.data.code == "400") {
                resolve(false)
                _this.codeLoading = false;
              } else {
                this.$toast(res.data.message);
                _this.codeLoading = false;
                resolve(true)
              }
            }
          );
        }
      })
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        const data = await this.getCode(captchaVerifyParam)
        resolve(data)
      })
    }
  },
  mounted() {
    this.$store.commit("userInfo");
  },
  destroyed: function() {
    clearInterval(this.dd);
    $(".alterphone .codebox .van-button").html(
      '<span class=\\"van-button__text\\">获取验证码</span>'
    );
  }
};
</script>

<style lang="less" scoped>
.alterphone {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;

  .save {
    width: 100%;
    height: 0.96rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: 0.3rem;
    color: #ffffff;
    line-height: 0.42rem;
  }
  .get-code {
    min-width: 1.68rem;
    height: 0.52rem;
    background: #fe5c42;
    border-radius: 0.08rem;
    color: #fff;
    border: none;
  }
  .van-cell-group {
    background-color: #fff;

    .van-cell {
      padding: 0.4rem 0.3rem;
      .van-field__control {
        padding-left: 0.3rem;
      }
    }
    .inputlabel {
      font-size: 0.4rem;
      margin-right: 0.4rem !important;
      position: relative;
      top: 0.04rem;
    }
    .van-cell:not(:last-child)::after {
      bottom: -0.44rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/phone.vue